import { ConversationMessageDto, MessageSender } from '../dto/conversation-message.dto';

export class ConversationMessageEntity {
  readonly id: string;
  readonly senderType: MessageSender;
  readonly content: string;
  readonly isRead: boolean;
  readonly readAt?: string;
  readonly createdAt: string;
  readonly createdAtDate: Date;

  constructor(dto: ConversationMessageDto) {
    this.id = dto.id;
    this.senderType = dto.senderType;
    this.content = dto.content;
    this.isRead = dto.isRead;
    this.readAt = dto.readAt;
    this.createdAt = dto.createdAt;
    this.createdAtDate = new Date(dto.createdAt);
  }

  get isGuest(): boolean {
    return this.senderType === 'guest';
  }

  get isHost(): boolean {
    return this.senderType === 'host';
  }

}
